<template>
  <modal name="renew-urgent-modal" width="280px" height="230px" class="renew-modal" :pivotY="0.4">
    <div class="title">填写续费月份</div>
    <div class="input-box">
      <number-input class="cube-input" placeholder="请输入续费时长(月)" :controls="false" :precision="0" :max="maxMonth" :min="1" v-model="monthDuration"></number-input>
      <span>月</span>
    </div>
    <div class="price">
      {{`总金额：${totalPrice}`}}
    </div>
    <div class="btn-box">
      <div @click="cancel">取消</div>
      <div @click="confirmRenew">确定续费</div>
    </div>
  </modal>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import { priceMixin } from 'common/js/price-mixin';
import calcPrice from 'common/js/price-calculator';

export default {
  mixins: [priceMixin],
  components: {
    NumberInput: VueNumericInput
  },
  props: {
    selectList: {
      default() {
        return []
      },
      type: Array
    },
  },
  data() {
    return {
      monthDuration: null
    }
  },
  computed: {
    maxMonth() {
      let maxMonthArr = this.selectList.map(item => (60 - item.usedMonthNum - item.rentFreeDuration));
      return Math.min.apply(null, maxMonthArr);
    },
    totalPrice() {
      let totalPrice = this.selectList.reduce((prev, curr) => {return prev + calcPrice(curr, this.monthDuration, 2)}, 0);
      return Number(totalPrice.toFixed(2));
    }
  },
  methods: {
    cancel() {
      this.monthDuration = null;
      this.$modal.hide('renew-urgent-modal');
    },
    confirmRenew() {
      this.$emit('confirm', this.monthDuration, this.totalPrice);
      this.monthDuration = null;
    }
  }
}
</script>

<style lang="scss">
.renew-modal {
  .v--modal {
    padding: 20px;
    border-radius: 10px;
  }
  .title {
    font-size: 17px;
    line-height: 24px;
    margin-bottom: 15px;
  }
  .input-box {
    width: 100%;
    position: relative;
    > span {
      position: absolute;
      right: 15px;
      top: 14px;
      font-size: 14px;
    }
  }
  .cube-input {
    width: 100%!important;
    height: 40px;
    .numeric-input {
      width: 100%;
      height: 40px;
      background: #F7F7F7;
      padding-right: 40px;
      border-color: #E6E6E6;
      outline: none;
      -webkit-appearance: none;
    }
  }
  .money {
    font-size: 14px;
    color: #666;
    margin-top: 15px;
  }
  .price {
    font-size: 14px;
    margin-top: 15px;
  }
  .btn-box {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    height: 50px;
    width: 100%;
    line-height: 50px;
    text-align: center;
    border-top: 1px solid #E5E5E5;
    > div:first-child {
      width: 50%;
      border-right: 1px solid #E5E5E5;
    }
    > div:nth-child(2) {
      width: 50%;
      color: #f90;
    }
  }
}

</style>


